/**
 * {@docCategory ScrollablePane}
 */
export var ScrollbarVisibility = {
  auto: 'auto',
  always: 'always'
};